import React from 'react';

interface AirplaneProps {
    angle: number;
    color?: string;
}

const getAirplaneTransformation = ({ scaleFactor, center, angle }: { scaleFactor: number; center: number; angle: number }) => {
    const translation = -center * (scaleFactor - 1);

    return `translate(${translation} ${translation}) scale(${scaleFactor}) rotate(${angle} ${center} ${center})`;
};

const Airplane: React.FC<AirplaneProps> = ({ angle, color = 'black' }) => (
    <svg viewBox='0 0 700 700'>
        <polygon
            fill={color}
            transform={getAirplaneTransformation({ scaleFactor: 0.3, center: 350, angle })}
            points='350 0 370 15 390 50 400 200 700 440 700 500 400 370 380 600 470 660 470 700 350 660 230 700 230 660 320 600 300 370 0 500 0 440 300 200 310 50 330 15'
        />
    </svg>
);

export default Airplane;
